import apiClient from '@/api/client';
import type { Shop } from '@/types/company';

export const createShop = async (
  companyId: string,
  data: Omit<Shop, 'id' | 'companyId'>,
): Promise<Shop> => {
  const response = await apiClient.post<Shop>(`/companies/${companyId}/shops`, data);
  return response.data;
};

export const updateShop = async (
  companyId: string,
  shopId: string,
  data: Partial<Omit<Shop, 'id' | 'companyId'>>,
): Promise<Shop> => {
  const response = await apiClient.put<Shop>(`/companies/${companyId}/shops/${shopId}`, data);
  return response.data;
};

export const deleteShop = async (companyId: string, shopId: string): Promise<void> => {
  await apiClient.delete(`/companies/${companyId}/shops/${shopId}`);
};
